import {t} from 'i18next'
import React from 'react'

export const uploadEmptyTemplate = (
	setValidDropArea: (value: (((prevState: boolean) => boolean) | boolean)) => void, validDropArea: boolean) => {
	return (
			<div
				onDragEnter={() => {
					setValidDropArea(true)
				}}
				onDragLeave={() => {
					setValidDropArea(false)
				}}
				className={`flex align-items-center pl-1 pr-1 pt-1 mt-1 pb-1 mb-1 button-height w-full
                    ${validDropArea ? ' drag-hover ' : ''}`}
				style={{
					background: 'transparent',
					opacity: '0.5'
				}}
			>
				<span
					className="fa-solid fa-cloud-arrow-up icon-blue mr-2 fa-xl min-width-220 center-icon"
				/>	<span
				style={{'fontSize': '1em'}}
				className="w-full secondary-text">{t<string>('core.drag_and_drop')}</span>
			</div>

	)
}
